import React from 'react';

export function Loading({ message = 'Carregando...' }) {
  return (
    <div style={{
      display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center',
      padding: 40, gap: 12
    }}>
      <div style={{
        width: 32, height: 32, border: '3px solid var(--nc-border)',
        borderTopColor: 'var(--nc-primary)', borderRadius: '50%',
        animation: 'spin 0.8s linear infinite'
      }} />
      <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
      <span className="nc-body-sm">{message}</span>
    </div>
  );
}
